import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';
// import AddIcon from '@material-ui/icons/Add';
// import { useSelector } from 'dva';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import RefreshIcon from '@material-ui/icons/Refresh';
import RuleML from './RuleML';
import DetailMLStyled from './DetailMLStyles';

// eslint-disable-next-line no-unused-vars
export default ({
  queryType,
  control,
  errors,
  setValue,
  tagCollectionInfo = null,
  setError,
  clearErrors,
  getValues,
  handleAddRuleData,
  handleAddRuleDataDelete,
  handleAddRuleDetailData,
  handleAddRuleDetailDataDelete,
  handleDetailDelete,
  handleRefreshDetail,
  setFieldValue,
  ruleLabelDirectoryList,
  handleAddTagRuleData,
  cascadeCallBack,
}) => {
  const [open, setOpen] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseSure = () => {
    setOpen(false);
    handleDetailDelete({
      id: deleteId,
    });
    setDeleteId();
  };
  return (
    <DetailMLStyled>
      <Box>
        {tagCollectionInfo &&
          Array.isArray(tagCollectionInfo) &&
          tagCollectionInfo.length > 0 &&
          tagCollectionInfo.map((item, index) => {
            return (
              <Box
                key={index}
                borderRadius="12px"
                bgcolor="background.paper"
                pb={4}
                pr={4}
                mb={0.5}
              >
                {/*满足规则s*/}
                <Box>
                  <RuleML
                    ruleList={item.tagCollectionRuleIn}
                    detailId={item.id}
                    tagCollectionInfo={tagCollectionInfo}
                    queryType={queryType}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    setError={setError}
                    clearErrors={clearErrors}
                    getValues={getValues}
                    handleAddRuleData={handleAddRuleData}
                    handleAddRuleDataDelete={handleAddRuleDataDelete}
                    handleAddRuleDetailData={handleAddRuleDetailData}
                    handleAddRuleDetailDataDelete={
                      handleAddRuleDetailDataDelete
                    }
                    handleAddTagRuleData={handleAddTagRuleData}
                    setFieldValueP={setFieldValue}
                    cLabel="满足"
                    pid={item.id}
                    cascadeCallBack={cascadeCallBack}
                    ruleLabelDirectoryList={ruleLabelDirectoryList}
                    showButton="hidden"
                  />
                </Box>
                {/*满足规则e*/}
                {/*排除规则s*/}
                <Box sx={{ marginTop: '30px' }}>
                  <RuleML
                    ruleList={item.tagCollectionRuleOut}
                    detailId={item.id}
                    tagCollectionInfo={tagCollectionInfo}
                    queryType={queryType}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    setError={setError}
                    clearErrors={clearErrors}
                    getValues={getValues}
                    handleAddRuleData={handleAddRuleData}
                    handleAddRuleDataDelete={handleAddRuleDataDelete}
                    handleAddRuleDetailData={handleAddRuleDetailData}
                    handleAddRuleDetailDataDelete={
                      handleAddRuleDetailDataDelete
                    }
                    handleAddTagRuleData={handleAddTagRuleData}
                    setFieldValueP={setFieldValue}
                    cLabel="排除"
                    pid={item.id}
                    ruleLabelDirectoryList={ruleLabelDirectoryList}
                    cascadeCallBack={cascadeCallBack}
                    showButton="hidden"
                  />
                </Box>
                {/*排除规则e*/}
                {queryType !== 'detail' && (
                  <Box
                    display="flex"
                    justifyContent="center"
                    gap="0 23px"
                    marginTop="10px"
                  >
                    {tagCollectionInfo.length > 1 && (
                      <Box
                        sx={{
                          width: '35px',
                          height: '35px',
                          padding: '6px 7px',
                          borderRadius: '50%',
                          background: '#fafafa',
                          boxShadow:
                            '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 1px 18px 0px rgba(0,0,0,0.12), 0px 6px 10px 0px rgba(0,0,0,0.14)',
                        }}
                        onClick={() => {
                          setOpen(true);
                          setDeleteId(item.id);
                        }}
                      >
                        <DeleteForeverIcon
                          sx={{
                            width: '100%',
                            height: '100%',
                            color: 'rgba(0, 0, 0, 0.87)',
                          }}
                        />
                      </Box>
                    )}
                    <Box
                      sx={{
                        width: '35px',
                        height: '35px',
                        padding: '6px 7px',
                        borderRadius: '50%',
                        background: '#fafafa',
                        cursor: 'pointer',
                        boxShadow:
                          '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 1px 18px 0px rgba(0,0,0,0.12), 0px 6px 10px 0px rgba(0,0,0,0.14)',
                      }}
                      onClick={() => {
                        handleRefreshDetail({ id: item.id });
                      }}
                    >
                      <RefreshIcon
                        sx={{
                          width: '100%',
                          height: '100%',
                          color: 'rgba(0, 0, 0, 0.87)',
                        }}
                      />
                    </Box>
                  </Box>
                )}
              </Box>
            );
          })}
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ width: '200px' }}
          >
            确认删除吗？
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            sx={{ color: '#999', width: '57px' }}
            onClick={handleClose}
          >
            取消
          </Button>
          <Button
            variant="text"
            sx={{ width: '57px' }}
            onClick={handleCloseSure}
            autoFocus
          >
            确定
          </Button>
        </DialogActions>
      </Dialog>
    </DetailMLStyled>
  );
};
